module.exports = __webpack_public_path__ + "static/Sahel-Bold-1944ec8a1b5122414c154d7a0add607c.woff";